export default __webpack_public_path__ + "static/media/washupNoVoucher.36c4457a.png";